import round from 'lodash/round';
import { calculateExtraWeightPrice } from '../../helpers/network';
import { DOMESTIC_SERVICES } from './constants';

const WEIGHTS = [5, 10, 20, 25, 30];

export const calculateDomesticPrices = prices => {
  const shipToShopBasePrice = prices[DOMESTIC_SERVICES.SHIP_TO_SHOP].baseRate;
  const doorToShopBase = round(
    shipToShopBasePrice +
      prices[DOMESTIC_SERVICES.SHIP_TO_SHOP].driverCollectionSurcharge,
    2
  );
  const nextDayDeliveryBasePrice =
    prices[DOMESTIC_SERVICES.PARCEL_NEXT_DAY].baseRate;
  const doorToDoorBasePrice = round(
    nextDayDeliveryBasePrice +
      prices[DOMESTIC_SERVICES.PARCEL_NEXT_DAY].driverCollectionSurcharge,
    2
  );

  const shopToShop = {
    base: shipToShopBasePrice,
  };
  const doorToShop = {
    base: doorToShopBase,
  };
  const nextDayDelivery = {
    fromShop: nextDayDeliveryBasePrice,
    doorToDoor: {
      base: doorToDoorBasePrice,
    },
    doorToDoorBy12: round(
      prices[DOMESTIC_SERVICES.PARCEL_BY_12].baseRate +
        prices[DOMESTIC_SERVICES.PARCEL_BY_12].driverCollectionSurcharge,
      2
    ),
    doorToDoorBy10: round(
      prices[DOMESTIC_SERVICES.PARCEL_BY_10_30].baseRate +
        prices[DOMESTIC_SERVICES.PARCEL_BY_10_30].driverCollectionSurcharge,
      2
    ),
  };
  const saturdayDelivery = {
    base: round(prices[DOMESTIC_SERVICES.PARCEL_SATURDAY].baseRate, 2),
    doorToDoor: round(
      prices[DOMESTIC_SERVICES.PARCEL_SATURDAY].baseRate +
        prices[DOMESTIC_SERVICES.PARCEL_SATURDAY].driverCollectionSurcharge,
      2
    ),
    doorToDoorBy12: round(
      prices[DOMESTIC_SERVICES.PARCEL_SAT_BY_12].baseRate +
        prices[DOMESTIC_SERVICES.PARCEL_SAT_BY_12].driverCollectionSurcharge,
      2
    ),
  };
  const sundayDelivery = {
    doorToDoor: round(
      prices[DOMESTIC_SERVICES.PARCEL_SUNDAY].baseRate +
        prices[DOMESTIC_SERVICES.PARCEL_SUNDAY].driverCollectionSurcharge,
      2
    ),
  };

  WEIGHTS.forEach(weight => {
    const key = `${weight}kg`;
    const extraWeightShip2Shop = calculateExtraWeightPrice({
      ...prices[DOMESTIC_SERVICES.SHIP_TO_SHOP],
      weight,
    });
    const extraWeightDoorToDoor = calculateExtraWeightPrice({
      ...prices[DOMESTIC_SERVICES.PARCEL_NEXT_DAY],
      weight,
    });

    doorToShop[key] = round(doorToShopBase + extraWeightShip2Shop, 2);
    shopToShop[key] = round(shipToShopBasePrice + extraWeightShip2Shop, 2);
    nextDayDelivery[key] = round(
      nextDayDeliveryBasePrice + extraWeightDoorToDoor,
      2
    );
    nextDayDelivery.doorToDoor[key] = round(
      doorToDoorBasePrice + extraWeightDoorToDoor,
      2
    );
  });

  return {
    shopToShop,
    doorToShop,
    nextDayDelivery,
    saturdayDelivery,
    sundayDelivery,
  };
};
